import events from "./dataset/events.json";

export default events;